import moment from 'moment'
import { LanguageISO } from 'utils/localisation'

// Save current locale
const currentLocale = moment.locale()
const localeDataEN = moment.localeData('en')
moment.updateLocale(moment.locale('en'), {
  // All fields are required, hence we copy over the content from the previous locale data object for EN
  longDateFormat: {
    LTS: localeDataEN.longDateFormat('LTS'),
    LT: localeDataEN.longDateFormat('LT'),
    L: 'YYYY-MM-DD',
    LL: localeDataEN.longDateFormat('LL'),
    LLL: 'YYYY-MM-DD HH:mm',
    LLLL: localeDataEN.longDateFormat('LLLL'),
  },
})
const localeDataDE = moment.localeData('de')
moment.updateLocale(moment.locale('de'), {
  // All fields are required, hence we copy over the content from the previous locale data object for DE
  longDateFormat: {
    LTS: localeDataDE.longDateFormat('LTS'),
    LT: localeDataDE.longDateFormat('LT'),
    L: 'DD.MM.YYYY',
    LL: localeDataDE.longDateFormat('LL'),
    LLL: 'DD.MM.YYYY HH:mm',
    LLLL: localeDataDE.longDateFormat('LLLL'),
  },
})
// Restore current locale, since we overwrite it when updating the locale formats
moment.locale(currentLocale)

export const enum DateFormatMoment {
  TIME = 'LT',
  DATE = 'L',
  DATE_TIME = 'LLL',
}

export const enum DateFormat {
  TIME = 'p',
  DATE = 'P',
  DATE_TIME = 'Pp',
  ISO_DATE = 'YYYY-MM-DD',
  DATE_TIME_WITH_TIMEZONE = 'Ppppp',
  LOCAL_DATE = 'D MMM, YYYY',
}

export function formatDate(date: Date, showTime: boolean = false): string {
  return showTime ? moment(date).format(DateFormatMoment.DATE_TIME) : moment(date).format(DateFormatMoment.DATE)
}

export const formatMomentShort = (date: string | Date | moment.Moment): string => {
  if (!date) {
    return ''
  }
  return moment(date).format(DateFormatMoment.DATE)
}

export const formatMomentLong = (date: string | Date | moment.Moment): string => {
  if (!date) {
    return ''
  }
  return moment(date).format(DateFormatMoment.DATE_TIME)
}

export function formatDateAndMonth(date: Date, lang: LanguageISO) {
  return `${date.getDate()} ${date.toLocaleDateString(lang, { month: 'short' })}`
}

export const formatToISODate = (date: string | Date | moment.Moment | null): string => {
  if (!date) {
    return ''
  }

  return moment(date, 'L', moment.locale()).format(DateFormat.ISO_DATE)
}
